export class Assert {
    static assert(p, s = null) {
        if (!p) {
            if (s != null) {
                console.log(s);
                throw new Error(s);
            }
            throw new Error('condition does not hold');
        }
    }
}
//# sourceMappingURL=assert.js.map